import { render, staticRenderFns } from "./_id.vue?vue&type=template&id=17a81613&"
import script from "./_id.vue?vue&type=script&lang=js&"
export * from "./_id.vue?vue&type=script&lang=js&"
import style0 from "~/assets/scss/sections/company/company.scss?vue&type=style&index=0&lang=scss&"
import style1 from "~/assets/scss/sections/company/companies-table.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports